<div *ngIf="privilegesView==='AccessDenied'||id==='lock'||id===''" class=" outside-container  mt-4" >
  <div class="box-container">
    <div class="container">
      <div  class="  d-flex justify-content-center" >

  <img src="../../../assets/images/AccessDeniedError.png" alt="">
</div>

 </div>
</div>
</div>
<div *ngIf="privilegesView==='VAMD'&&id!='lock'&&id!=''" class="outside-container mt-4">
    <div class="box-container ">
        <div class="container">
            <div class="title ">

              <div class="row">
                <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
               <div class="col-md-7 d-flex justify-content-center">Reporting Configration</div>
               <div class=" col-md-3 row ">
                 <div class="d-flex justify-content-end">
                  <button *ngIf="showDataEntity" class="btn btn-outline-primary btn-sm " (click)="onAddDataEntity()"><img src="assets/images/Add_24.png"></button>
                 
               </div>
                </div>
              </div>
            
            </div> 
            </div>
            </div>
          </div>
          <div *ngIf="privilegesView==='VAMD'&&id!='lock'&&id!=''" class="outside-container ">
            <div class="box-container ">
                <div class="container ">
                  <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
                 
                 
                    <div class="col-md-2  "  style="background-color: #d2e1f5; border-radius: 4px; content: right; padding-top: 10px; height:70vh;overflow-y: auto; ">
                      <div class="col-md-12 ">
                      <span *ngIf="id" class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickDataEntity()"     [ngClass]="{'activity' :showDataEntity}">Billing Entity</span></span>
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickTags()"     [ngClass]="{'activity' :showTags}">Reporting Tags</span></span>


                    </div>
                      
                    </div>

                   <div class="col-md-10" style="height:70vh; overflow-y: auto;">

                     <div *ngIf="showDataEntity&&id" class="col-md-12 card" style="min-height: 100%;" >

                      <div class=" row mt-3 " style="padding: 10px;">
                       
                        
                        <div class="col-md-12 " >
                         
                          <table mat-table
                          [dataSource]="DataEntity" multiTemplateDataRows style="background-color: transparent;">
                         
                          <ng-container matColumnDef="expand">
                            <th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                            <td mat-cell *matCellDef="let element">
                            <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                              <mat-icon *ngIf="expandedElement !== element">arrow_right</mat-icon>
                              <mat-icon *ngIf="expandedElement === element">arrow_drop_down</mat-icon>
                            </button>
                            </td>
                            </ng-container>
                           <ng-container matColumnDef="Name">
                             <th mat-header-cell *matHeaderCellDef>Name</th>
                             <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowdataEntityClick(element)"> {{element?.entityName}} </td>
                           </ng-container>
                           <ng-container matColumnDef="accountCode">
                            <th mat-header-cell *matHeaderCellDef>Accounts Code</th>
                            <td mat-cell *matCellDef="let element"  > {{element?.accountCode||"-"}}</td>
                          </ng-container>

                          <ng-container matColumnDef="isEnabled">
                           <th mat-header-cell *matHeaderCellDef> Is Enabled </th>
                           <td mat-cell *matCellDef="let element"> {{element?.isEnabled}} </td>
                          </ng-container>
                          
                         
                          
                          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                          <ng-container matColumnDef="expandedDetail">
                          <td mat-cell *matCellDef="let element" [attr.colspan]="columnsDataEntityDisplay.length">
                          <div class="example-element-detail row"
                           [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                           <div class=" card mt-2 mb-2 pb-2 pt-2 shadow">
                            <div class="col-md-12 d-flex justify-content-start mt-2">
                           <div class="col-md-6 row">
                           <span class="col-md-6 bold">State</span>
                           <span class="col-md-6">{{element?.state||"-"}}</span>
                           </div>
                           </div>
                           <div class="col-md-12 d-flex justify-content-start mt-2">
                             <div class="col-md-6 row">
                             <span class="col-md-6 bold">GST Number</span>
                             <span class="col-md-6">{{element?.entityGST||"-"}}</span>
                             </div>
                             </div>
                             <div class="col-md-12 d-flex justify-content-start mt-2">
                               <div class="col-md-6  row">
                               <span class="col-md-6 bold">GST Email</span>
                               <span class="col-md-6">{{element?.email||"-"}}</span>
                               </div>
                               </div>
                               <div class="col-md-12 d-flex justify-content-start mt-2">
                                <div class="col-md-6  row">
                                <span class="col-md-6 bold">Gst Name</span>
                                <span class="col-md-6">{{element?.gstName||"-"}}</span>
                                </div>
                                </div>
                                <div class="col-md-12 d-flex justify-content-start mt-2">
                                    <div class="col-md-6  row">
                                    <span class="col-md-6 bold">GST Address</span>
                                    <span class="col-md-6">{{element?.address||"-"}}</span>
                                    </div>
                                    </div>
                                    <div class="col-md-12 d-flex justify-content-start mt-2">
                                        <div class="col-md-6  row">
                                        <span class="col-md-6 bold">GST Phone</span>
                                        <span class="col-md-6">{{element?.phone||"-"}}</span>
                                        </div>
                                        </div>
                                        <div class="col-md-12 d-flex justify-content-start mt-2">
                                            <div class="col-md-6  row">
                                            <span class="col-md-6 bold">GST Accounts Code</span>
                                            <span class="col-md-6">{{element?.gstAccountCode||"-"}}</span>
                                            </div>
                                            </div>
                                            <div class="col-md-12 d-flex justify-content-start mt-2">
                                                <div class="col-md-6  row">
                                                <span class="col-md-6 bold">GST Type</span>
                                                <span class="col-md-6">{{element?.gstType||"-"}}</span>
                                                </div>
                                                </div>
                                                <div class="col-md-12 d-flex justify-content-start mt-2">
                                                  <div class="col-md-6  row">
                                                  <span class="col-md-6 bold">Accounts Code</span>
                                                  <span class="col-md-6">{{element?.accountCode||"-"}}</span>
                                                  </div>
                                                  </div>
                             </div>
                          </div>
                          </td>
                          </ng-container>
                          
                          <tr mat-header-row *matHeaderRowDef="columnsDataEntityDisplay"></tr>
                          <tr mat-row *matRowDef="let element; columns: columnsDataEntityDisplay;"
                          class="example-element-row">
                          </tr>
                          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                          <tr class="mat-row" *matNoDataRow>
                          <td  class="mat-cell" colspan="4">There is no data in this table</td>
                          </tr>
                          </table>
                          
                          
                          </div>
                          
                      
                    
                    </div> 
                      </div>
                     
                      <div *ngIf="showTags" class="col-md-12 card" style="min-height: 100%;" >



                        <div class=" row mt-3 " style="padding: 10px;">
                       
                        
                          <div class="col-md-12 " >
                            <div *ngIf="!id" class="col-md-12 d-flex justify-content-start" >
                              <mat-form-field  class="col-md-4" appearance="outline">
                                <mat-label>Tag Name</mat-label>
                                <input matInput type="text"  name="tag" autocomplete="off" maxlength="36" [(ngModel)]="tagName">
    
                              </mat-form-field>
                              <button  *ngIf="tagName && !disableTag" mat-flat-button  style="width: 20%; height: 55px; color: white; background-color: #1e8f5a; margin-left: 8px;font-weight: bold;" (click)="AddNewTags()" [disabled]="!tagName || disableTag">Save</button>
                              <button *ngIf="!tagName || disableTag" disabled mat-flat-button  style="width: 20%; height: 55px; color: white; background-color: #64be94; margin-left: 8px;font-weight: bold;"  >Save</button>
                              <div class="col-md-3">
                                <span class="form-control shadow pointer" (click)="popoveritemsContent.toggle($event)">Profile Field - RM Mapping </span>
                                <p-overlayPanel  #popoveritemsContent class="col-md-12" [style]="{'max-width':'50rem'}" >

                                  <div style="max-height: 400px;overflow-y:auto">
                                    <table class="styled-tables">
                                      <thead>
                                        <tr>
                                            <th>Field Name</th>
                                            <th>Backend Value</th>
                                           
                                        </tr>
                                    </thead>     
                                    <tbody>

                                      <tr *ngFor="let field of fareFields">
                                        <th>{{ field.label }}</th>
                                        <td>
                                          {{field.key}}
                                          <span class="shadow" style="font-size: 20px; cursor: pointer;"
                                                (click)="copyToClipboard(field.key)">⎘</span>
                                        </td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </p-overlayPanel>
                              </div>                              <div class="col-md-3">
                                <span class="form-control shadow pointer" (click)="popoveritemContent.toggle($event)">Fixed RM Mapping </span>

                                <p-overlayPanel  #popoveritemContent class="col-md-12" [style]="{'max-width':'50rem'}" >
                                  <div>
                                    <table class="styled-tables" >
                                      <thead>
                                        <tr>
                                            <th>Field Name</th>
                                            <th>Backend Value</th>
                                           
                                        </tr>
                                    </thead>        
                                      <tbody>
                                        <tr>
                                          <th>Employee Code</th>
                                          <td>:employeeCode <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':employeeCode')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Designation</th>
                                          <td>:designation <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':designation')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Band</th>
                                          <td>:band <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':band')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Location</th>
                                          <td>:location <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':location')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Department</th>
                                          <td>:department <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':department')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Cost Center</th>
                                          <td>:costCenter <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':costCenter')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Project Code</th>
                                          <td >:projectCode <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':projectCode')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Contact Number</th>
                                          <td >:contactNumber <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':contactNumber')">⎘</span></td>
                                        </tr>
                                        
                                         
                                      </tbody>
                                  </table> 
                                  </div>
                                  </p-overlayPanel>

                              </div>
                            </div>
                            <div *ngIf="id" class="col-md-12 d-flex justify-content-end" >
                              <div class="col-md-3">
                                <span class="form-control shadow pointer" (click)="popoveritemsContent.toggle($event)">Profile Field - RM Mapping </span>
                                <p-overlayPanel  #popoveritemsContent class="col-md-12" [style]="{'max-width':'50rem'}" >


                                  <div style="max-height: 400px;overflow-y:auto">
                                    <table class="styled-tables">
                                      <thead>
                                        <tr>
                                            <th>Field Name</th>
                                            <th>Backend Value</th>
                                           
                                        </tr>
                                    </thead>     
                                    <tbody>

                                      <tr *ngFor="let field of fareFields">
                                        <th>{{ field.label }}</th>
                                        <td>
                                          {{field.key}}
                                          <span class="shadow" style="font-size: 20px; cursor: pointer;"
                                                (click)="copyToClipboard(field.key)">⎘</span>
                                        </td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </p-overlayPanel>
                              </div>
                              <div class="col-md-3">
                                <span class="form-control shadow pointer" (click)="popoveritemContent.toggle($event)">Fixed RM Mapping </span>

                                <p-overlayPanel  #popoveritemContent class="col-md-12" [style]="{'max-width':'50rem'}" >
                                  <div>
                                    <table class="styled-tables" >
                                      <thead>
                                        <tr>
                                            <th>Field Name</th>
                                            <th>Backend Value</th>
                                           
                                        </tr>
                                    </thead>        
                                      <tbody>
                                        <tr>
                                          <th>Employee Code</th>
                                          <td>:employeeCode <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':employeeCode')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Designation</th>
                                          <td>:designation <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':designation')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Band</th>
                                          <td>:band <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':band')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Location</th>
                                          <td>:location <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':location')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Department</th>
                                          <td>:department <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':department')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Cost Center</th>
                                          <td>:costCenter <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':costCenter')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Project Code</th>
                                          <td >:projectCode <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':projectCode')">⎘</span></td>
                                        </tr>
                                        <tr>
                                          <th>Contact Number</th>
                                          <td >:contactNumber <span  class="shadow" style="font-size: 20px;cursor: pointer;" (click)="copyToClipboard(':contactNumber')">⎘</span></td>
                                        </tr>
                                        
                                         
                                      </tbody>
                                  </table> 
                                  </div>
                                  </p-overlayPanel>

</div>
</div>
                            <table mat-table
                            [dataSource]="tagList" multiTemplateDataRows style="background-color: transparent;">
                           
                            <ng-container matColumnDef="expand">
                              <th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                              <td mat-cell *matCellDef="let element">
                              <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                                <mat-icon *ngIf="expandedElement !== element">arrow_right</mat-icon>
                                <mat-icon *ngIf="expandedElement === element">arrow_drop_down</mat-icon>
                              </button>
                              </td>
                              </ng-container>
                              <ng-container matColumnDef="foreignSequence">
                                <th mat-header-cell *matHeaderCellDef>Foreign Sequence</th>
                                <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" > 
                                  <input type="text" maxlength="36" (keypress)="onlyNumberKey($event)" class="form-control" [(ngModel)]="element.foreignSequence">

                                </td>
                              </ng-container>
                              <ng-container matColumnDef="tagName">
                                <th mat-header-cell *matHeaderCellDef>Parameter/Granularity/<br>Invoice Print/Show(Trav/Cons)/<br>Editable</th>
                                <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" > {{element?.tagName}} </td>
                              </ng-container>
                             <ng-container matColumnDef="required">
                               <th mat-header-cell *matHeaderCellDef>Required ?</th>
                               <td mat-cell *matCellDef="let element"  > 
                                <mat-select class="form-control" name="required" [(ngModel)]="element.required">
                                  <mat-option class="mat-primary" value="D">Default(Not Applicable)</mat-option>
                                  <mat-option class="mat-primary" value="N">N/A</mat-option>
                                  <mat-option class="mat-primary" value="O">Optional</mat-option>
                                  <mat-option class="mat-primary" value="C">Required</mat-option>
                                </mat-select> 
                                 </td>
                             </ng-container>
  
                             <ng-container matColumnDef="fixedValue">
                              <th mat-header-cell *matHeaderCellDef> Fixed Values (| separated,:  Profile Refrence )	</th>
                              <td mat-cell *matCellDef="let element">
                               <textarea name="fixedValue" class="form-control" [(ngModel)]="element.tagFixedValue"   cols="30" rows="1"></textarea>
                                </td>
                             </ng-container>
                            <ng-container matColumnDef="displayName">
                             <th mat-header-cell *matHeaderCellDef>  Display Name (Only if Overridden)</th>
                             <td mat-cell *matCellDef="let element">
                              <input type="text" maxlength="36" class="form-control" [(ngModel)]="element.tagDisplayName">
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="granularityOverride">
                              <th mat-header-cell *matHeaderCellDef> Granularity Override</th>
                              <td mat-cell *matCellDef="let element">
                                
                                <mat-select class="form-control" name="required" [(ngModel)]="element.tagType">
                                  <mat-option class="mat-primary" value="PAX">Passenger</mat-option>
                                  <mat-option class="mat-primary" value="CART">Cart</mat-option>
                                  <mat-option class="mat-primary" value="SEGMENT">Segment</mat-option>
                                  <mat-option class="mat-primary" value="TRIP">Trip</mat-option>
                                
                                
                                
                                </mat-select> 
                                 </td>
                             </ng-container>
                            
                           
                            
                            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                            <ng-container matColumnDef="expandedDetail">
                            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsDatatags.length">
                            <div class="example-element-detail row"
                             [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                             <div class="  mt-2 mb-2 pb-2 pt-1 ">
                              <div class="col-md-12 d-flex justify-content-start mt-2">
                                <textarea class="form-control" name="tagValue"  cols="30" rows="2" [(ngModel)]="element.tagValue"></textarea>
                              
                                
                              </div>
                              <div class="col-md-12 d-flex justify-content-end mt-2">
                              <button *ngIf="element.tagType"  mat-flat-button  style="width: 20%; height: 55px; color: white; background-color: #1e8f5a; margin-left: 8px;font-weight: bold;" (click)="UpdateNewTags(element)" [disabled]=" disableTag">Update</button>
                              <button *ngIf="!element.tagType"  mat-flat-button  style="width: 20%; height: 55px; color: white; background-color: #81b89f; margin-left: 8px;font-weight: bold;"  [disabled]=" disableTag">Update</button>

                            </div>
                            
                               </div>
                            </div>
                            </td>
                            </ng-container>
                            
                            <tr mat-header-row *matHeaderRowDef="columnsDatatags"></tr>
                            <tr mat-row *matRowDef="let element; columns: columnsDatatags;"
                            class="example-element-row">
                            </tr>
                            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                            <tr class="mat-row" *matNoDataRow>
                            <td  class="mat-cell" colspan="4">There is no data in this table</td>
                            </tr>
                            </table>
                            
                            
                            </div>
                            
                        
                      
                      </div> 




                      </div>

                    </div>
                    </div>
                </div>

                <div class="modal " id="myMod"  [style.display]="showDataEntityPopup ? 'block' : 'none'" >
                  <div class="modal-dialog" >
                      <div class="modal-content " >
                          <div class="modal-header title">
                            <h4 *ngIf="action==='newEntity'" class="modal-title">Add Billing Entity</h4>
                            <h4 *ngIf="action==='updateEntity'" class="modal-title">Edit Billing Entity</h4>

                            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                            <div class="modal-body">
                            <div class="col-md-12 mt-3 " *ngIf="showDataEntityPopup">
                              <div class="col-md-12 d-flex justify-content-center" >
                              <div class="col-md-12 row " >
                                  <div class=" col-md-12 ">
                                      <form [formGroup]="DataEntityRegFg"  (ngSubmit)="AddDataEntity()" autocomplete="off"  class=" row" >
                                       
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label> Name</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" formControlName="entityName">
                                          <small *ngIf="DataEntityRegFg.controls['entityName'].dirty && DataEntityRegFg.controls['entityName'].invalid" class="warn">Please Enter  Name!</small>

                                        </mat-form-field>

                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label> Account Code</mat-label>
                                          <input matInput type="text"  name="name"  autocomplete="off" formControlName="accountCode">
                                          <small *ngIf="DataEntityRegFg.controls['accountCode'].dirty && DataEntityRegFg.controls['accountCode'].invalid" class="warn"> Enter Account Code!</small>

                                        </mat-form-field>
                                        
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Is Enabled</mat-label>
                                          <mat-select matNativeControl name="enable" formControlName="isEnabled">
                                            <mat-option value="true">True</mat-option>
                                            <mat-option value="false">False</mat-option>

                                          </mat-select>  

                                        </mat-form-field> 
                                         
                                        <mat-form-field class="col-md-3" appearance="outline">
                                          <mat-label>Type</mat-label>
                                          <mat-select matNativeControl name="enable" formControlName="type">
                                            <mat-option value="C">Official</mat-option>
                                            <mat-option value="P">Personal</mat-option>

                                          </mat-select>  

                                        </mat-form-field> 
                                        <h5  class="modal-title mb-3">GST Details</h5>

                                        <mat-form-field class="col-md-4" appearance="outline">
                                            <mat-label>State</mat-label>
                                            <mat-select matNativeControl name="state" formControlName="state">
                                                <mat-option *ngFor="let item of stateData" [value]="item.stateName">{{item.stateName}}</mat-option>

                                              </mat-select> 

                                          </mat-form-field> 
                                          <mat-form-field  class="col-md-4" appearance="outline">
                                            <mat-label>GST Number</mat-label>
                                            <input matInput type="text"  name="GSTnumber"  autocomplete="off" formControlName="entityGST">

                                          </mat-form-field> 
                                          <mat-form-field class="col-md-4" appearance="outline">
                                            <mat-label>GST Email</mat-label>
                                            <input matInput type="text"  name="email" autocomplete="off" formControlName="email">

                                          </mat-form-field> 
                                          <mat-form-field  class="col-md-4" appearance="outline">
                                            <mat-label>GST Name</mat-label>
                                            <input matInput type="text"  name="gstName" autocomplete="off" formControlName="gstName">

                                          </mat-form-field> 
                                          <mat-form-field  class="col-md-4" appearance="outline">
                                            <mat-label>GST Address</mat-label>
                                            <input matInput type="text"  name="Prefix" autocomplete="off" formControlName="address">

                                          </mat-form-field> 
                                          <mat-form-field  class="col-md-4" appearance="outline">
                                            <mat-label>GST Phone</mat-label>
                                            <input matInput type="text"  name="gstPhone" autocomplete="off" formControlName="phone">

                                          </mat-form-field> 
                                          <mat-form-field class="col-md-4" appearance="outline">
                                            <mat-label>GST Accounts Code</mat-label>
                                            <input matInput type="text"   name="storeSuffix" autocomplete="off" formControlName="gstAccountCode" >

                                          </mat-form-field>  
                                          <mat-form-field  class="col-md-4" appearance="outline">
                                            <mat-label>GST Type</mat-label>
                                            <mat-select matNativeControl name="type" formControlName="gstType">
                                                <mat-option value="Non SEZ">Non SEZ</mat-option>
                                                <mat-option value="SEZ Exemption">SEZ Exemption</mat-option>
                                                <mat-option value="SEZ IGST">SEZ IGST</mat-option>


                                              </mat-select> 

                                          </mat-form-field> 
                                          
                                          <mat-form-field  class="col-md-4" appearance="outline">
                                            <mat-label>City</mat-label>
                                            <input matInput type="text"  name="city" autocomplete="off" formControlName="city">
                                          </mat-form-field>   

                                          <mat-form-field  class="col-md-4" appearance="outline">
                                            <mat-label>Postal Code</mat-label>
                                            <input matInput type="text"  name="postalCode" autocomplete="off" formControlName="postalCode">
                                          </mat-form-field>                      
                                        </form>
                                  </div>
                                  </div>
                                  </div>                                      
                            </div>

                              <div class="modal-footer">
                               
                                <button *ngIf="action==='updateEntity'" class="btn btn-outline-success c-width-100px shadow "  (click)="AddDataEntity()" [disabled]="DataEntityRegFg.invalid">Update</button>

                                <button *ngIf="action==='newEntity'" class="btn btn-outline-success c-width-100px shadow "  (click)="AddDataEntity()" [disabled]="DataEntityRegFg.invalid">Save</button>
                              <button  type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                         
                              </div>
                            </div>
                            </div>
                    </div>
                </div>
                